import { Component } from 'react'
import PropTypes from 'prop-types'

class ProfileManager extends Component {
    constructor(props) {
        super(props)

        window.profilelist = this.profileList
    }

    shouldComponentUpdate() {
        return false
    }

    // Populate the list of profiles
    // provided by launcher backend
    profileList = (server, profiles) => {
        try {
            this.props.setServerProfiles(server, profiles)
        } catch (error) {
            console.info(`Encountered error while running profileList: ${error.message}`)
        }
    }

    render() {
        return null
    }
}

ProfileManager.propTypes = {
    setServerProfiles: PropTypes.func,
}

export default ProfileManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/ProfileManager/component.js